<div class="row">
    <div class="col-12">
        <app-datatable [options]="dtConfig"></app-datatable>
    </div>
</div>

<div class="modal-footer">
    <button class="btn btn-info" (click)="modalRef.hide()">Cerrar</button>
</div>